import React from 'react'
import { ParallaxBanner } from 'react-scroll-parallax';

const Promo = props => {
  return (
    <ParallaxBanner
      layers={[
        {
          image: '/images/background4.jpg',
          amount: 0.4,
        },
      ]}
      style={{
          height: '130%',
      }}
    >
      <section className="dzsparallaxer auto-init height-is-based-on-content use-loading" data-options='{direction: "reverse", settings_mode_oneelement_max_offset: "150"}'>
        {/* Parallax Image */}
        <div className="divimage dzsparallaxer--target w-100 u-bg-overlay g-bg-img-hero g-bg-white-opacity-0_7--after" style={{height: "140%", backgroundImage: "url(/assets/img-temp/1920x1080/img7.jpg)"}}></div>
        {/* End Parallax Image */}

        <div className="container u-bg-overlay__inner g-py-150--md g-py-80">
          <div className="row">
            {/* Section Content */}
            <div className="col-lg-6 order-2 order-sm-1 g-mb-0 g-mb-50--sm g-mb-0--lg">
              <div className="u-heading-v2-3--bottom g-brd-primary g-mb-30">
                <h2 className="h4 u-heading-v2__title g-color-gray-dark-v2 g-font-weight-600 text-uppercase">Most Quality Solution</h2>
              </div>
              <p className="g-font-size-16 g-line-height-2 g-mb-30">Morbi a suscipit ipsum. Suspendisse mollis libero ante. Pellentesque finibus convallis nulla vel placerat. Nulla ipsum dolor sit amet, consectetur adipiscing elitut eleifend nisl. Ullam elementum tincidunt massa, a pulvinar leo ultricies ut.</p>

              <div className="g-mb-30">
                <img className="u-block-hover__main--grayscale g-width-100 g-opacity-0_6 g-mr-40 g-mb-10 g-mb-0--sm" src="/img-temp/200x100/img8.png" alt="Image description" />
                <img className="u-block-hover__main--grayscale g-width-100 g-opacity-0_6 g-mr-40 g-mb-10 g-mb-0--sm" src="/img-temp/200x100/img6.png" alt="Image description" />
                <img className="u-block-hover__main--grayscale g-width-100 g-opacity-0_6" src="/img-temp/200x100/img3.png" alt="Image description" />
              </div>

              <a href="#" className="btn btn-xl u-btn-primary text-uppercase g-font-weight-600 g-font-size-12 rounded g-mr-15 g-mb-15 g-mb-0--sm">Buy Full Version</a>
              <small className="d-block d-sm-inline-block g-color-gray-dark-v5 g-font-size-12">*Exclusive item on Wrapboostrap Marketpalce</small>
            </div>
            {/* End Section Content */}

            {/* Video Icon */}
            <div className="col-lg-6 order-1 order-sm-2 align-self-center text-center g-pos-rel g-mb-40 g-mb-0--sm">
              <a className="js-fancybox d-block g-pos-rel" href="javascript:;" data-src="//vimeo.com/167434033" data-speed="350" data-caption="Lightbox Gallery">
                <span className="u-icon-v3 u-icon-size--xl u-block-hover--scale u-shadow-v24 g-bg-white g-color-gray-dark-v1 g-color-primary--hover g-font-size-20 rounded-circle g-cursor-pointer g-mb-10">
                    <i className="fa fa-play g-pos-rel g-left-2"></i>
                  </span>
              </a>
              <p className="g-color-gray-dark-v5">Watch our 2 min video.</p>
            </div>
            {/* End Video Icon */}
          </div>
        </div>
      </section>
    </ParallaxBanner>
  )
}

export default Promo
